(function() {
	'use strict';
	angular.module('app.setup')
		.controller('projectTypeForm', projectTypeForm);

	projectTypeForm.$inject = ['$scope', 'projectTypeService', 'storeService'];
	function projectTypeForm($scope, projectTypeService, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		// view model functions
		vm.projectType = $scope.projectType;
		vm.leanDirFactoryNdx = $scope.leanDirFactoryNdx;
		vm.isSaveButtonDisabled = false;
		vm.action = $scope.action;
		vm.close = close;
		vm.save = save;
		init();
		
		function init() {
			if (vm.action == 'Edit') {
				vm.originalProjectType = jQuery.extend({}, vm.projectType, true); 
			} 
			else {
				vm.projectType = {
					factoryNdx: vm.leanDirFactoryNdx
				};
			}
		}

		function save() {
			vm.isSaveButtonDisabled = true;
			if (typeof vm.projectType.id === 'undefined') {
				projectTypeService.addProjectType(vm.projectType, adminConfig.factory.id).then(function(message) {
					$scope.result(message, message == 'Project type created successfully');
					vm.isSaveButtonDisabled = false;
				});
			} else {
				var lastModified = (typeof vm.projectType.lastModified === 'undefined') ? (new Date()).toUTCString() : (new Date(vm.projectType.lastModified)).toUTCString();
				if (vm.projectType.name !== vm.originalProjectType.name) {
					var projectType = {
						id: vm.projectType.id,
						name: vm.projectType.name,
						factoryNdx: vm.leanDirFactoryNdx
					};
					projectTypeService.updateProjectType(projectType, lastModified, adminConfig.factory.id).then(function (message) {
						if (_.isString(message)) { 
							$scope.result(message, false);
						} else {
							$scope.result('Project Type updated successfully', message.data.id == vm.projectType.id);
						}
					});
				} else {
					$scope.result('', true);
				}
				vm.isSaveButtonDisabled = false;
			}
		}
		
		function close() {
			$scope.result('', false);
		}
	}
})();
